module.exports = __webpack_public_path__ + "static/media/img_redenvelope_banner.241be9e7.png";